import React from 'react';
import TableHead from './TableHead';
import TableBody from './TableBody';
import Pagination from './CardFooter';
import TableRow from './TableRow';

class Table extends React.Component {
    constructor(props) {
        super(props);

        const { terminals } = this.props;

        this.state = {
            terminals: terminals,
            pageOfItems: [],
        };

        this.onChangePage = this.onChangePage.bind(this);
    }
    onChangePage(pageOfItems) {
        // update state with new page of items
        this.setState({ pageOfItems: pageOfItems });
    }
    render(){
        const empty = (this.state.terminals.length === 0);

        if (empty) {
            return (
                <div className="rounded-0 alert alert-warning m-0">
                    Nenhum terminal cadastrado.
                </div>
            ); 
        }
        return(
            <div className="table-responsive">
                <table className="table align-items-center table-flush">
                    <TableHead />
                    {this.state.pageOfItems.map(item =>
                        <TableRow key={item.id} {...item} />
                    )}
                </table>
                <Pagination items={this.state.terminals} onChangePage={this.onChangePage}/>
            </div>
        )
    }
}

export default Table;


// WEBPACK FOOTER //
// ./src/components/Pages/Terminals/Table.js